import { ReportOptions } from 'models/component-print-models';
import { DatasetDataInfo } from 'models/dataset-models';
import { DashboardComponentPropsBase } from 'components/pages/dashboard/components/interfaces';
import { HighlightColor } from '../../../../product-template-table/utils/interfaces';

export interface IDatasetSetpointConfig extends DashboardComponentPropsBase<ReportOptions> {
    showTagColumn?: boolean;
    hideHeader?: boolean;
    showSetpointColumn?: boolean;
    updateFrequency?: number;
    showTableTitles?: boolean;
    compactMode?: boolean;
    tableTitles?: ITableTitles;
    values: Array<IDatasetSetpointValueProp>;
}

export interface ITableTitles {
    tagTitle?: string;
    datasetTitle?: string;
    datasetValueTitle?: string;
    setpointValueTitle?: string;
}

export interface IDatasetSetpointValueProp {
    tag?: string;
    name?: string;
    dataset?: string;
    setpointDataset?: string;
    validation?: Array<IDatasetSetPointValidationProps>;
    highlightColor?: HighlightColor;
}

export interface IDatasetSetPointValidationProps {
    difference: ValidationDifference;
    diff: number;
    highlightColor: HighlightColor;
}

export enum ValidationDifference {
    PERCENT = 'PERCENT',
    ABS = 'ABS',
}

export interface IDatasetSetpointRowConfig {
    showTagColumn?: boolean;
    showSetpointColumn?: boolean;
    tag?: string;
    name?: string;
    dataset?: DatasetDataInfo;
    setpointDataset?: DatasetDataInfo;
    validation?: Array<IDatasetSetPointValidationProps>;
    datasetSelected: boolean;
    setpointSelected: boolean;
    compactMode?: boolean;
    nameBeforeWasEmpty?: boolean;
    highlightColor?: HighlightColor;

    setIdentifiers(id: string, ctrlPressed: boolean, doubleClick: boolean): void;
}
